import { Injectable } from '@angular/core';
import { PortalSettings } from '../types/base-portal-settings.type';

@Injectable({ providedIn: 'root' })
export class BasePortalSettingsService {
  private defaults: PortalSettings = {
    links: {
      urls: {},
      visibility: { header: [], leftSidebar: [] },
    },
  };

  private config: PortalSettings = this.defaults;

  setSettings(config: PortalSettings): void {
    this.config = config ?? this.defaults;
  }

  getSettingsSnapshot(): PortalSettings {
    return this.config;
  }
}
